import { useState, type FunctionComponent, type PropsWithChildren } from 'react';
import { SystemAdminCompanySelect } from './components';
import { FullscreenLoading } from 'components/FullscreenLoading';
import { UserGroup } from 'utils/graphql/hooks';
import { useAuthUserContext } from 'utils/provider/AuthUserProvider';

const companySelectGroupSet = new Set([UserGroup.SystemAdmin, UserGroup.SystemUser]);

export const AuthenticatedRoute: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { authUser, isLoading } = useAuthUserContext();

  // only for system admin company select
  const [selectedCompanyId, setSelectedCompanyId] = useState<string | undefined>();

  if (isLoading) {
    return <FullscreenLoading />;
  }

  // this can only happen on manual user creation
  if (authUser?.userError) {
    throw authUser.userError;
  }

  if (authUser?.group && companySelectGroupSet.has(authUser.group) && !selectedCompanyId) {
    return <SystemAdminCompanySelect setSelectedCompanyId={setSelectedCompanyId} />;
  }

  return <>{children}</>;
};
